import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { DateTimeStyle } from 'Components/Layout/Grid/types';
import { WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { useSelector } from 'react-redux';
import { getDryMassGridFieldSet } from '../../gridFieldSets';
import { IEmbeddedTestProps } from '../../types';

let BsEnDryMassesMultiTraysGridSection: React.FC<IEmbeddedTestProps> = ({
  createWorksheetSelector,
  isEmbeddedTest,
}) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  return (
    <>
      <WorksheetGridFieldSection name="DryingTrays">
        <WorksheetRecordGrid
          name="DryingTrays"
          orientation="horizontal"
          scrollLinkId="mddCompaction"
          rowHeaderWidth={200}
          recordProps={{
            width: 130,
            preventRemove: true,
            preventCreate: true,
          }}
          fieldSet={[
            {
              name: 'DryMassReadings',
              recordProps: (i: number) => ({
                enforceAtLeastOneRecord: true,
                preventRemove: 'all-but-last',
                preventCreate: dryMassEntryOption === 'Never',
                removeConfirm: {
                  confirm: true,
                  confirmTitle: 'Delete Dry Mass Reading',
                  confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
                  confirmButtonText: 'Delete',
                },
              }),
              fields: [...getDryMassGridFieldSet(dryMassEntryOption, DateTimeStyle.Separate)],
            },
            {
              name: 'ConstantDrySoilMass',
              component: <Field input={<TextOutput />} />,
            },
          ]}
        />
      </WorksheetGridFieldSection>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Measurements.TotalDryMass" label="Total Material Dry Mass" />
        {isEmbeddedTest && <Field input={<TextOutput />} name="Results.MoistureContentPercent" />}
      </ListFieldSection>
    </>
  );
};

BsEnDryMassesMultiTraysGridSection = withInjectedProps(BsEnDryMassesMultiTraysGridSection);

export { BsEnDryMassesMultiTraysGridSection };
export default BsEnDryMassesMultiTraysGridSection;
